import ImprovementLeverCard from "@/bizminer/App/PillarInsights/ImprovementLevers/_components/ImprovementLeverCard.tsx";
import type { BizminerImprovementLever } from "@/types/serializers";

interface CardViewProps {
  improvementLevers: BizminerImprovementLever[];
  onSelect: (lever: BizminerImprovementLever) => void;
}

export default function CardView({
  improvementLevers,
  onSelect,
}: CardViewProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
      {improvementLevers.map((improvementLever) => (
        <ImprovementLeverCard
          key={improvementLever.id}
          improvementLever={improvementLever}
          onClick={() => onSelect(improvementLever)}
        />
      ))}
    </div>
  );
}
